<template>
    <!--permission-->
    <v-dialog
      v-model="askPermissionDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      :width="dialogWidth"
    >
      <v-card class="pa-5">
        <v-container class="pa-0 d-flex justify-center">
          <v-icon size="70" color="warning">mdi-alert-circle-outline</v-icon>
        </v-container>
        <v-card-text class="pa-0 text-body-1 text-center my-3">
          {{ txtPerm }}
          <br />
          {{ detailPerm }}
        </v-card-text>
        <v-container
          v-if="permType"
          class="pa-0 d-flex justify-center align-center gap-2"
        >
          <v-btn
            color="primary"
            height="32"
            @click="accept"
          >
          {{ $t('yes') }}
          </v-btn>
          <v-btn
            color="error"
            height="32"
            @click="askPermissionDialog = false"
          >
          {{ $t('no') }}
          </v-btn>
        </v-container>
        <v-container
          v-if="!permType"
          class="pa-0 d-flex justify-center align-center gap-2"
        >
          <v-btn
            color="warning"
            height="32"
            @click="downloadTools"
          >
          {{ btnTxt }}
          </v-btn>
        </v-container>
      </v-card>
    </v-dialog>
</template>

<script>
export default {
  props: {
    askPerm: Boolean,
    txtPerm: String,
    detailPerm: String,
    dialogWidth: Number,
    permType: Boolean,
    btnTxt: String
  },
  data () {
    return {
      askPermissionDialog: false
    }
  },
  methods: {
    accept () {
      this.$emit('accept')
      this.askPermissionDialog = false
    },
    downloadTools () {
      window.open('https://abriron.com/abrironapp/abriron-tools-windows.rar', '_blank')
      this.askPermissionDialog = false
    }
  },
  watch: {
    askPerm (val) {
      if (val) {
        this.askPermissionDialog = true
      }
    },
    askPermissionDialog (val) {
      if (!val) {
        this.$emit('deny')
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
